<template>
  <v-page page="Rate Plan Maintenance" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3 style="min-height: 46px;">
                  <v-flex align-center>
                    <div class="text-xs-left align-center" style="font-size: 20px; font-weight: 600;">Rate Plan Maintenance</div>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
  import VPage from "../../layouts/Default.vue";
  import axios from "axios";
  import * as helper from "../../helpers/global.js";


  export default {
    name: "RatePlanMaintenance",

    components: {
      VPage,
    },

    data: () => ({
      dialog: false,
      search: "",
      loading: true,

      breadcrumb: [
        {
        text: "Rate Plan Maintenance",
        disabled: false,
        href: "#/rate-plan-maintenance"
        },
      ],
    }),
  };

</script>

<style scoped>
  table.v-table tbody td,
  table.v-table tbody th {
    height: 22px;
    font-size: 14px;
  }

  table.v-table tbody th {
    background-color: #4caf50;
  }

  table.v-table tbody tr:not(:last-child) {
    height: 22px;
    font-size: 14px;
  }
  .TierButton {
    border-color: #4caf50 !important;
    border-width: 1px !important;
    border-style: solid !important;
    color: #4caf50 !important;
    box-shadow: none !important;
    background-color: transparent !important;
  }
  .TierButton:hover {
    background-color: #4caf50 !important;
    color: white !important;
  }
</style>
